import { Toast, Notify } from 'vant'
import router from "@/router"
import store from "@/store"

/*
  是否为移动端
*/
export function isPlatformMobile() {
  const flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
  if (flag == null) {
    return false
  }
  return true
}


/**
 * 是否为微信环境
 * 配置的域名白名单为 wx.copoiot.com，在非此域名下，亦为 false
 */
 export function isWeiXin() {
  if (location.host !== 'wx.copoiot.com') return false
  const ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/MicroMessenger/i)?.includes('micromessenger')) {
    return true
  }
  return false
}

export function converImageURL(URL) {
  if (typeof URL === 'string') {
    if (URL.includes('http')) {
      return URL
    }
    URL = 'https://www.copoiot.com/api/file/head' + (URL.split('')[0] === '/' ? URL : `/${URL}`)
    return URL
  }
  return URL
}

/*
  通用提示信息
*/
export function showPhoneAlarm(show, way, type, length, code, title, message) {
  // 根据状态码决定显示颜色
  if (type === null) {
    const first = (code + '').substr(0, 1)
    switch (first) {
      case '2':
        type = 'success'
        break
      case '3':
        type = 'warning'
        break
      case '4':
        type = 'danger'
        break
      case '5':
        type = 'danger'
        break
      default:
        type = 'primary'
        break
    }
  }
  // 登录已失效
  if (code === 403) {
    show = true
    store.dispatch("user/logout")
    router.push({ path: '/login' })
  }
  // 成功是否显示
  if (show === true) {
    if ((message === '') || (message === null)) {
      if (title === '') {
        if (type === 'success') {
          return true
        }
        return false
      } else {
        message = title + '成功'
      }
    }
    if (way === 'toast') {
      // Toast.success(message)
      Toast(message)
    } else if (way === 'notify') {
      Notify({ type: type, message: message })
    } else {
      Toast(message)
    }
  }
  // 返回值
  if (type === 'success') {
    return true
  }
  return false
}

